/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { getIdSports } from '../../../common/data/sports';
import { getModel } from '../../../services/api.service';
import { getModel as getModel2 } from '../../../services/api2.service';
import { IRegionReturn, IListRegionReturn } from '../interfaces/region';

/**
 * Get all regions
 */
export const getAllRegions = async (query): Promise<IListRegionReturn> => {
    let urlModel = `regions`;
    if (query && query.sport) {
        const sportId = getIdSports(query.sport);
        urlModel = `${urlModel}?sportId=${sportId ? sportId : ''}`;
    }

    if (query.filter === 1) {
        urlModel = `${urlModel}&filter=${query.filter}`;
    }

    if (query.filterOrigin) {
        urlModel = `${urlModel}&filterOrigin=${query.filterOrigin}`;
    }

    if (query.type) {
        urlModel = `${urlModel}&type=${query.type}`;
    }
    const data = await getModel2(urlModel);
    return data;
};

/**
 * Get region by ID
 */
export const getRegionById = async (id: string): Promise<IRegionReturn> => {
    const urlModel = `regions/${id}`;
    const data = await getModel(urlModel);
    return data;
};
